import { useFeatureFlag } from "@origin-digital/feature-flags";
import { KrakenAuthNav } from "@origin-digital/myaccount-navigation";
import * as React from "react";
import { MasqueradeBanner } from "../Banner/MasqueradeBanner";
import { Header } from "../Header";
import { Navigation } from "../Navigation";
import { NoNavigationHeader } from "../Navigation/NoNavigationHeader";
import { Survey } from "../Survey";
import { FEATURE_FLAGS } from "../../client/features";

interface BaseAppContentProps {
  actionBar?: Window["oetal"]["pageData"]["actionBar"];
  showHeader: Window["oetal"]["pageData"]["showHeader"];
  crisisBanner: Window["oetal"]["pageData"]["crisisBanner"];
  title: string;
  isNative?: boolean;
}

export const UnauthAppContent: React.FC<BaseAppContentProps> = ({
  showHeader,
  actionBar = {},
  title,
  crisisBanner = "none",
  isNative,
}) => {
  const isPropertySelectorEnabled = useFeatureFlag(
    FEATURE_FLAGS.PROPERTY_SELECTOR
  );
  const showPropertySelector =
    isPropertySelectorEnabled && actionBar?.propertySelector?.enabled;
  const showServiceSelector =
    showPropertySelector && actionBar?.propertySelector?.showServiceSelector;
  return (
    <>
      {showHeader === true && <Navigation />}
      {showHeader === "scoped" && <NoNavigationHeader />}
      <Header
        title={actionBar.title || title}
        desktopVariant={actionBar.desktopVariant}
        headingComponent={actionBar.component}
        isNative={isNative}
        hideActionBar={actionBar.hidden}
        mobileNavButton={actionBar.mobileNavButton}
        crisisBanner={crisisBanner}
        showPropertySelector={showPropertySelector}
        showServiceSelector={showServiceSelector}
        showAllProperties={actionBar?.propertySelector?.showAllProperties}
        secondaryColor={actionBar.secondaryColor}
      />
    </>
  );
};

export const KrakenAppContent: React.FC<BaseAppContentProps> = ({
  actionBar = {},
  showHeader,
  title,
  crisisBanner = "none",
  isNative,
}) => {
  const isPropertySelectorEnabled = useFeatureFlag(
    FEATURE_FLAGS.PROPERTY_SELECTOR
  );
  const showPropertySelector =
    isPropertySelectorEnabled && actionBar?.propertySelector?.enabled;
  const showServiceSelector =
    showPropertySelector && actionBar?.propertySelector?.showServiceSelector;

  return (
    <>
      <MasqueradeBanner />
      {showHeader && (
        <KrakenAuthNav desktopVariant={actionBar.desktopVariant} />
      )}

      <Header
        title={actionBar.title || title}
        desktopVariant={actionBar.desktopVariant}
        headingComponent={actionBar.component}
        hideActionBar={actionBar.hidden}
        isNative={isNative}
        mobileNavButton={actionBar.mobileNavButton}
        crisisBanner={crisisBanner}
        showPropertySelector={showPropertySelector}
        showServiceSelector={showServiceSelector}
        showAllProperties={actionBar?.propertySelector?.showAllProperties}
        secondaryColor={actionBar.secondaryColor}
      />
      <Survey />
    </>
  );
};
